// =============================================================
// Registry de módulos — fonte única de verdade
// -------------------------------------------------------------
// Usado em 3 lugares:
//   1. SuperAdminDashboard (TenantModal)  -> painel de seleção
//   2. Sidebar                            -> mostrar/ocultar itens
//   3. Viagens                            -> mostrar/ocultar campos
//
// status: 'available' = já funciona (toggle liberado)
//         'soon'      = roadmap (aparece no painel, mas bloqueado)
// =============================================================

// Sempre ativos — não aparecem como toggle, nunca somem do sistema.
export const CORE_MODULES = ['dashboard', 'clientes', 'viagens', 'reservas', 'usuarios'];

export const MODULE_REGISTRY = [
  {
    category: 'Transporte rodoviário',
    icon: 'Bus',
    modules: [
      { key: 'bagagem',    label: 'Controle de bagagem',      status: 'available' },
      { key: 'encomendas', label: 'Encomendas e cargas',      status: 'available' },
      { key: 'qr',         label: 'Check-in via QR Code',     status: 'available' },
    ],
  },
  {
    category: 'Aventura e excursões',
    icon: 'Mountain',
    modules: [
      { key: 'dificuldade', label: 'Nível de dificuldade por viagem',          status: 'available', tag: 'Novo' },
      { key: 'atividade',   label: 'Tipo de atividade (trekking, montanha...)', status: 'available', tag: 'Novo' },
      { key: 'guias',       label: 'Gestão de guias de turismo',                status: 'available', tag: 'Novo' },
      { key: 'itinerario',  label: 'Itinerário multi-dia (hotel, refeição)',    status: 'available', tag: 'Novo' },
      { key: 'ficha',       label: 'Ficha de aptidão física do viajante',       status: 'available', tag: 'Novo' },
      { key: 'waitlist',    label: 'Lista de espera (waitlist)',                status: 'available', tag: 'Novo' },
      { key: 'galeria',     label: 'Galeria de fotos (via Google Drive)',       status: 'available', tag: 'Novo' },
    ],
  },
  {
    category: 'Financeiro',
    icon: 'DollarSign',
    modules: [
      { key: 'parcelamento', label: 'Parcelamento de pagamento',          status: 'soon' },
      { key: 'custos',       label: 'Controle de custos por viagem',       status: 'soon' },
      { key: 'relatorios_av',label: 'Relatórios financeiros avançados',    status: 'soon' },
    ],
  },
  {
    category: 'Documentos e contratos',
    icon: 'FileText',
    modules: [
      { key: 'contrato',   label: 'Geração de contrato de viagem (PDF)', status: 'soon' },
      { key: 'assinatura', label: 'Assinatura digital (pad in-app)',     status: 'soon' },
      { key: 'termo',      label: 'Termo de responsabilidade / waiver',  status: 'soon' },
    ],
  },
  {
    category: 'Comunicação',
    icon: 'MessageCircle',
    modules: [
      { key: 'whatsapp', label: 'Envio WhatsApp massivo',            status: 'soon' },
      { key: 'email',    label: 'Notificações automáticas por e-mail', status: 'soon' },
    ],
  },
];

// Lista achatada de todos os módulos liberados (status available).
export const AVAILABLE_MODULES = MODULE_REGISTRY
  .flatMap(c => c.modules)
  .filter(m => m.status === 'available')
  .map(m => m.key);

// Templates prontos — só incluem módulos liberados.
export const TEMPLATES = {
  transporte: ['bagagem', 'encomendas', 'qr'],
  aventura:   ['dificuldade', 'atividade', 'guias', 'itinerario', 'ficha', 'waitlist', 'galeria'],
  completo:   [...AVAILABLE_MODULES],
};

export const TEMPLATE_LABELS = {
  transporte: 'Turismo Rodoviário',
  aventura:   'Turismo de Aventura',
  completo:   'Completo',
  custom:     'Personalizado',
};

// Qual template a lista de módulos corresponde (ou 'custom').
export function detectTemplate(modulos = []) {
  const set = new Set(modulos);
  for (const [name, keys] of Object.entries(TEMPLATES)) {
    if (keys.length === set.size && keys.every(k => set.has(k))) return name;
  }
  return 'custom';
}

// Helper central: um módulo está ativo para esta agência?
//   - core   -> sempre true
//   - sem config (tenant legado) -> true (não quebra nada que já existia)
//   - com config -> presença na lista
export function moduleEnabled(branding, key) {
  if (CORE_MODULES.includes(key)) return true;
  const mods = branding?.modulos;
  if (!Array.isArray(mods)) return true;
  return mods.includes(key);
}
